import { render, staticRenderFns } from "./ViajeFormRegalias.vue?vue&type=template&id=67084328"
import script from "./ViajeFormRegalias.vue?vue&type=script&lang=js"
export * from "./ViajeFormRegalias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports